import { addDefaultSrc } from "../../utilities";
import DropboxPlayer from "../DropboxPlayer";
import { TikTokThumbnail, YoutubeThumbnail } from "./ThumbnailByPlatform";

const defaultIcon = require("@src/assets/images/vyrill/default.png").default;
const youTubeIcon =
  require(`@src/assets/images/vyrill/icons/youtube_icon.png`).default;
const tikTokIcon =
  require(`@src/assets/images/vyrill/icons/tiktok_icon.png`).default;
const googleDriveIcon =
  require(`@src/assets/images/vyrill/icons/google_drive_icon.png`).default;
const dropboxIcon =
  require(`@src/assets/images/vyrill/reports/dropbox_icon.svg`).default;
const instagramIcon =
  require(`@src/assets/images/vyrill/icons/instagram_icon.png`).default;

const MainThumbnail = ({ selectedImage, singleVideoDetail }) => {
  const dropboxThumbnail = (
    <div className="videoWrapper">
      <DropboxPlayer
        styleClass={"videoFrame"}
        videoUrl={singleVideoDetail.video_url}
      />
    </div>
  );

  const tiktokThumbnail = (
    <TikTokThumbnail
      selectedImage={selectedImage}
      customStyles={{ background: "black" }}
      imgStyles={{ objectFit: "contain", minWidth: "130px", height: "291px" }}
    />
  );

  const instagramThumbnail = (
    <img
      width={549}
      height={291}
      style={{ background: "black", objectFit: "contain" }}
      src={singleVideoDetail?.thumbnail_url}
      onError={(event) => addDefaultSrc(event, defaultIcon)}
    />
  );

  return (
    <div
      className="MainImageContainer"
      style={{ width: "550px", height: "363px", border: "1px solid #D9D9D9" }}
    >
      {selectedImage && selectedImage.includes("blob:") ? (
        <div className="main-image-container">
          <img src={selectedImage || defaultIcon} className="image-src" />
        </div>
      ) : (
        <>
          {singleVideoDetail.platform === "localVideo" && (
            <video
              width={549}
              height={291}
              style={{ background: "black" }}
              src={singleVideoDetail.video_url}
            />
          )}
          {singleVideoDetail.platform === "GoogleDrive" && (
            <img
              src={singleVideoDetail?.thumbnail_url || ""}
              width={549}
              height={291}
              style={{ background: "black", objectFit: "contain" }}
            />
          )}
          {singleVideoDetail.platform === "Dropbox" && dropboxThumbnail}
          {singleVideoDetail.platform === "Youtube" && (
            <YoutubeThumbnail selectedImage={selectedImage} />
          )}
          {singleVideoDetail.platform === "Tiktok" && tiktokThumbnail}
          {singleVideoDetail.platform === "Instagram" && instagramThumbnail}
        </>
      )}
      <div className="FileLinkBox">
        <div className="PlatformLogo">
          {singleVideoDetail.platform === "Youtube" && (
            <img src={youTubeIcon} width={25} />
          )}
          {singleVideoDetail.platform === "Tiktok" && (
            <img src={tikTokIcon} width={25} />
          )}
          {singleVideoDetail.platform === "Dropbox" && (
            <img src={dropboxIcon} width={25} />
          )}
          {singleVideoDetail.platform === "GoogleDrive" && (
            <img src={googleDriveIcon} width={25} />
          )}
          {singleVideoDetail.platform === "Instagram" && (
            <img src={instagramIcon} width={25} />
          )}
        </div>
        <div className="FileLinkTitle">
          <span>File Link</span>
        </div>
        <div className="LinkContainer">
          <a
            href={
              singleVideoDetail.video_url || singleVideoDetail.thumbnail_url
            }
            rel="noreferrer"
            target="_blank"
          >
            <span style={{ color: "#2F80ED" }}>
              {singleVideoDetail.video_url || singleVideoDetail.thumbnail_url}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MainThumbnail;
